import { Stack, Typography } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit";
import { ThemeContext } from "../../../Shared/Theme/ThemeContext"
import { useContext } from "react";

export function EditportalButton({...params}){

    const { mode } = useContext(ThemeContext);

    let editportalButtonState = params.editportalButtonState
    let setEditportalButtonState = params.setEditportalButtonState
    let handleClick = params.handleClick

    let lightColors = ["#02203B", "#06569D", "#138BF6"  ]
    let darkColors = ["#138BF6", "#75BCFA", "#D8ECFD"  ]

    let onButtonPage = false
    let url = window.location.pathname
    if (url.startsWith('/editpage/')) onButtonPage = true

    const handleButtonHover = (event) => {
        event.preventDefault()
        if (onButtonPage) setEditportalButtonState('hover')
        else if (editportalButtonState !== 'active') setEditportalButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setEditportalButtonState('default')
        if (onButtonPage) setEditportalButtonState('active')
        else if (editportalButtonState !== 'active') setEditportalButtonState('default')
    }

    let editportalButtonColor = ''

    if (mode === 'light'){
        if (editportalButtonState === 'active') editportalButtonColor = lightColors[0]
        else if (editportalButtonState === 'default') editportalButtonColor = lightColors[1]
        else if (editportalButtonState === 'hover') editportalButtonColor = lightColors[2]
    } 
    else if (mode === 'dark'){
        if (editportalButtonState === 'active') editportalButtonColor = darkColors[0]
        else if (editportalButtonState === 'default') editportalButtonColor = darkColors[1]
        else if (editportalButtonState === 'hover') editportalButtonColor = darkColors[2]
    } 

    let labelFormatting = params.labelFormatting
    let labelStyling = {color: editportalButtonColor}

    return (
        <Stack width={'71px'} height={'55px'} direction={'column'} alignItems={'center'} zIndex={100}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onClick={(event) => handleClick(event)}>
            <EditIcon paddingBottom={'10px'} sx={{color: editportalButtonColor, width: '33px', height: '45px'}}/>
            <Typography sx={[labelFormatting, labelStyling]}>Edit Portal</Typography>
        </Stack>
    )
}
